// @ts-nocheck
import vuetify from "../vuetify";
import { createApp, h } from 'vue';
import UiErrorHandler from "@/components/ui/ErrorHandler/Error";
import router from "@modules/app/router";
import store from "@/store";

export default {
  install(app) {
    async function renderErrorComponent(error, redirectUrl, isHTML, sessionExpiredMode) {
      // Create a container for the error component
      const container = document.createElement('div');
      document.body.appendChild(container);
      
      // Create a new app instance for the error component
      const errorApp = createApp({
        render() {
          return h(UiErrorHandler, {
            error,
            redirectUrl,
            isHTML,
            sessionExpiredMode,
            onClose: () => {
              // Clean up when the error component closes
              errorApp.unmount();
              document.body.removeChild(container);
            }
          });
        }
      });
      
      // Use the same plugins as the main app
      errorApp.use(vuetify);
      errorApp.use(router);
      errorApp.use(store);
      
      // Mount the error component
      errorApp.mount(container);
    }

    app.config.globalProperties.$error = renderErrorComponent;
  },
};
